import {
  AuditReportsGipEvidenceExportOptionsDto,
  AuditReportsPublicJobDtoStatusEnum,
  AuditReportsPublicJobDtoStatusEnumKey,
  useAuditReportsEvidenceExportGipReport,
  useAuditReportsGetGipReportEvidenceExportUrl,
  useAuditReportsGetGipReportExportStatus,
} from '@mi-front/api-v2';
import { reportError } from '@app/core/integrations/bugsnag';
import { useCreatedReport } from '@app/modules/audit/modules/global-audit/hooks/useCreatedReport';
import { useQueryClient } from '@tanstack/react-query';
import { ReportExportApi } from './report-export-api';

export function useGipExportApi(): ReportExportApi {
  const queryClient = useQueryClient();

  const exportMutation = useAuditReportsEvidenceExportGipReport({
    mutation: {
      onSuccess: (_data, variables) => {
        if (variables?.id) {
          queryClient.invalidateQueries({
            queryKey: useCreatedReport.queryKey(variables.id),
          });
        }
      },
      onError: (error: any) => {
        reportError(error);
      },
    },
  });

  return {
    exportReport: async (id: string, options: unknown) => {
      await exportMutation.mutateAsync({
        id,
        data: options as AuditReportsGipEvidenceExportOptionsDto,
      });
    },
    useExportStatus: (id: string, enabled: boolean) =>
      useAuditReportsGetGipReportExportStatus(id || '', {
        query: {
          enabled,
          refetchInterval: (query) => {
            const status = query.state.data?.status as AuditReportsPublicJobDtoStatusEnumKey;

            return status === AuditReportsPublicJobDtoStatusEnum.IN_PROGRESS ||
              status === AuditReportsPublicJobDtoStatusEnum.WAITING
              ? 1000
              : false;
          },
        },
      }),
    useExportUrl: (id: string, enabled: boolean) =>
      useAuditReportsGetGipReportEvidenceExportUrl(id, {
        query: {
          enabled,
        },
      }),
  };
}
